import { toast } from "react-toastify";
//prime React
//components
import Panel from "../../../../../../components/panel/panel.jsx";
import ModalUpdateInstallments from "./ModalUpdateInstallments.jsx";

//utils
import ModalAnticipateInstallments from "./ModalAnticipateRegressiveInstallments.jsx";
import ModalAnticipateSelectedInstallments from "./ModalAnticipateSelectedInstallments.jsx";
import ModalRenegotiateInstallments from "./ModalRenegotiateInstallments.jsx";
import { generateBillet } from "../../../../../../services/Parcel/generateBillet.js";
import ModalReadjustInstallments from "./ModalReadjustInstallments.jsx";
import ModalCreateInstallments from "./ModalCreateInstallments.jsx";
import ModalUpdateInstruction from "./ModalUpdateInstruction.jsx";
import ModalUpdateDueDate from "./ModalUpdateDueDate.jsx";
import { ParcelHeader } from "./ParcelHeader.jsx";
import { TableData } from "./TableDate.jsx";
import { useParcelContext } from "./ParcelContext.jsx";
import ModalReverseInstallments from "./ModalReverseInstallments.jsx";
import ModalReverseShipping from "./ModalReverseShipping.jsx";

const Parcel = () => {
  const {
    itemsSelected,
    setItemsSelected,
    idSale,
    nameCli,
    nameBlock,
    nameLand,
    setSelectAll,
    refetch,
    parcels,
    enterpriseId,
    bank,
  } = useParcelContext();

  console.log("Banco atual:", bank);

  const sendPrintBillet = () => {

    if (itemsSelected.length == 0) {
      return toast.warning("Selecione ao menos um boleto para impressão.")
    }

    let obj = {
      enterprise_id: enterpriseId,
      installments_id: [],
    };

    const selectedParcelIds = itemsSelected.map(
      (selectedParcel) => selectedParcel.id
    );

    const loadingNotification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    selectedParcelIds.forEach((id) => {
      obj.installments_id.push(id);
    });
    generateBillet(obj)
      .then((result) => {
        if (!result.error) {
          // Exibir notificação de sucesso
          toast.update(loadingNotification, {
            render: "Imprimindo Boletos...",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
          if (result.link) {
            // Função para fazer o download do PDF
            // function downloadPDF(url) {
            //   // Realiza uma solicitação Ajax para obter os dados do PDF
            //   fetch(url)
            //     .then((response) => response.blob())
            //     .then((blob) => {
            //       const blobURL = URL.createObjectURL(blob);
            //       const link = document.createElement("a");
            //       link.href = blobURL;
            //       link.setAttribute(
            //         "download",
            //         `${nameCli}-${nameBlock}-${nameLand}.pdf`
            //       );
            //       document.body.appendChild(link);
            //       link.click();
            //       document.body.removeChild(link);
            //     })
            //     .catch((error) => {
            //       console.error("Erro ao fazer o download do PDF:", error);
            //     });
            // }

            function downloadPDF(url) {
              window.open(url, '_blank');
            }

            // Chamada para baixar o PDF
            downloadPDF(result.link);
          }

          refetch().then(() => {
            // Após a atualização, exibir notificação de sucesso
            toast.update(loadingNotification, {
              render: "Boletos Impressos",
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "success",
              isLoading: false,
            });
          });
        } else {
          toast.update(loadingNotification, {
            render: result.error,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        // Se houver um erro durante a impressão de Boletos,
        toast.update(loadingNotification, {
          render: "Não foi possível imprimir boletos!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao gerar boletos:", error);
      });
    setItemsSelected([]);
    setSelectAll([]);
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <ParcelHeader sendPrintBillet={sendPrintBillet} />
        <Panel mainCss="mt-4 pt-3">
          <div>
            <h3>{`${nameCli} -  ${nameBlock} / ${nameLand} `}</h3>
          </div>
          <TableData />

          <ModalUpdateDueDate
            position="center"
            dynamicTitle="Alterar Data de Vencimento"
            closable={true}
          ></ModalUpdateDueDate>
          <ModalUpdateInstruction
            position="center"
            dynamicTitle="Atualizar Instruções"
            closable={true}
          ></ModalUpdateInstruction>
          <ModalCreateInstallments
            position="center"
            dynamicTitle="Adicionar Parcelas"
            closable={true}
          ></ModalCreateInstallments>
          <ModalUpdateInstallments
            position="center"
            dynamicTitle="Atualizar Parcelas"
            closable={true}
          ></ModalUpdateInstallments>
          <ModalAnticipateInstallments
            position="center"
            dynamicTitle="Antecipar Parcelas"
            closable={true}
          ></ModalAnticipateInstallments>
          <ModalAnticipateSelectedInstallments
            position="center"
            dynamicTitle="Antecipar Parcelas"
            closable={true}
          ></ModalAnticipateSelectedInstallments>
          <ModalRenegotiateInstallments
            position="center"
            dynamicTitle="Renegociar Parcelas"
            closable={true}
          ></ModalRenegotiateInstallments>
          <ModalReadjustInstallments
            position="center"
            dynamicTitle="Reajustar Parcelas"
            closable={true}
          ></ModalReadjustInstallments>
          <ModalReverseInstallments
            position="center"
            dynamicTitle="Reverter Parcelas"
            closable={true}
          ></ModalReverseInstallments>
          <ModalReverseShipping
            
            position="center"
            dynamicTitle="Reenviar Remessa"
            closable={true}
          ></ModalReverseShipping>
        </Panel>
      </div>
    </>
  );
};

export default Parcel;
